import React from 'react';
import { I18n } from 'js/components/common/I18n';
import { Control } from 'js/components/common/Fields/Control';
import { withField } from 'js/components/common/Fields/withField';

import { RadioShallow } from './components/RadioShallow';

import style from './Radio.scss';

export const RadioBare = ({
    /* rff render props */
    input,
    meta = {},

    /* user provided props */
    id,
    name,
    hint,
    label,
    onClick,
    hintTop,
    labelTop,
    classNames,
    className = '',

    ...radioDomProps
}) => {
    const labelTopContent = typeof labelTop === 'string'
        ? <I18n tKey={labelTop} defaultValue={labelTop} />
        : labelTop;

    return (
        <Control
            id={id}
            meta={meta}
            animate={true}
            hint={hintTop}
            label={labelTopContent}
            onClick={onClick}
            className={`${className} ${style.control}`}
            classNames={{ content: style.content, ...classNames }}
        >
            <RadioShallow
                id={id}
                hint={hint}
                name={name}
                label={label}
                classNames={classNames}
                {...input}
                {...radioDomProps}
                {...meta.submitting ? { disabled: true } : {}}
            />
        </Control>
    );
};

export const withRadio = Wrapped => props => <Wrapped {...props} type="radio" />;

export const Radio = withRadio(withField(RadioBare));
